import { createSlice, current } from '@reduxjs/toolkit';
import {
	getDistanceElevationList,
	getDistanceElevationItem,
	addNewDistanceElevation,
	updateDistanceElevation,
	deleteDistanceElevation,
} from './thunk';

export const initialState = {
	itemDistanceElevationList: [],
	itemDistanceElevation: null,
	isDistanceElevationLoading: false,
	isDistanceElevationSuccess: false,
	statementList: [],
	isLoadingList: false,
	isAdding: false,
	isAdded: false,
	isAddError: false,
	isUpdating: false,
	isUpdated: false,
	isUpdateError: false,
	isDeleting: false,
	isDeleted: false,
	isDeleteError: false,
	requireCloseModal: false,
};

const DistanceElevationSlice = createSlice({
	name: 'DistanceElevation',
	initialState,
	reducers: {
		setRequireCloseModal(state, action) {
			state.requireCloseModal = action.payload;
		},
		clearDistanceElevation(state) {
			state.itemDistanceElevationList = [];
			state.statementList = [];
		},
	},
	extraReducers: builder => {
		builder.addCase(getDistanceElevationList.pending, state => {
			state.isLoadingList = true;
			state.isDistanceElevationSuccess = false;
		});

		builder.addCase(getDistanceElevationList.fulfilled, (state, action) => {
			state.itemDistanceElevationList = action.payload;
			state.statementList = action.payload;
			state.isLoadingList = false;
			state.isDistanceElevationSuccess = true;
		});

		builder.addCase(getDistanceElevationList.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isDistanceElevationSuccess = false;
		});

		builder.addCase(getDistanceElevationItem.pending, state => {
			state.isDistanceElevationLoading = true;
			state.isDistanceElevationSuccess = false;
		});

		builder.addCase(getDistanceElevationItem.fulfilled, (state, action) => {
			state.itemDistanceElevation = action.payload;
			state.isDistanceElevationLoading = false;
			state.isDistanceElevationSuccess = true;
		});

		builder.addCase(getDistanceElevationItem.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isDistanceElevationLoading = false;
			state.isDistanceElevationSuccess = false;
		});

		builder.addCase(addNewDistanceElevation.pending, state => {
			state.isLoadingList = true;
			state.isAdding = true;
			state.isAdded = false;
			state.isAddError = false;
		});

		builder.addCase(addNewDistanceElevation.fulfilled, (state, action) => {
			state.itemDistanceElevationList.push(action.payload);
			state.statementList.push(action.payload);
			state.isLoadingList = false;
			state.isAdding = false;
			state.isAdded = true;
			state.isAddError = false;
			state.requireCloseModal = true;
		});

		builder.addCase(addNewDistanceElevation.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isAdding = false;
			state.isAddError = true;
		});

		builder.addCase(updateDistanceElevation.pending, state => {
			state.isLoadingList = true;
			state.isUpdating = true;
			state.isUpdated = false;
			state.isUpdateError = false;
		});

		builder.addCase(updateDistanceElevation.fulfilled, (state, action) => {
			state.itemDistanceElevationList = state.itemDistanceElevationList.map(item =>
				item._id.toString() === action.payload._id.toString()
					? { ...item, ...action.payload }
					: item
			);
			state.statementList = state.statementList.map(item =>
				item._id.toString() === action.payload._id.toString()
					? { ...item, ...action.payload }
					: item
			);
			state.isLoadingList = false;
			state.isUpdating = false;
			state.isUpdated = true;
			state.isUpdateError = false;
			state.requireCloseModal = true;
		});

		builder.addCase(updateDistanceElevation.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isUpdating = false;
			state.isUpdateError = true;
		});

		builder.addCase(deleteDistanceElevation.pending, state => {
			state.isLoadingList = true;
			state.isDeleting = true;
			state.isDeleted = false;
			state.isDeleteError = false;
		});

		builder.addCase(deleteDistanceElevation.fulfilled, (state, action) => {
			state.itemDistanceElevationList = current(state.itemDistanceElevationList).filter(
				item => item._id.toString() !== action.payload._id.toString()
			);
			state.statementList = current(state.statementList).filter(
				item => item._id.toString() !== action.payload._id.toString()
			);
			state.isLoadingList = false;
			state.isDeleting = false;
			state.isDeleted = true;
			state.isDeleteError = false;
			state.requireCloseModal = true;
		});

		builder.addCase(deleteDistanceElevation.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isDeleting = false;
			state.isDeleteError = true;
		});
	},
});

export const { setRequireCloseModal, clearDistanceElevation } = DistanceElevationSlice.actions;

export default DistanceElevationSlice.reducer;
